import type { ExcelConfiguration } from "@/lib/excel-configurator/core";
import type { Shipment } from "@/types";

/** Configuração de colunas com que o configurador arranca para uma expedição. */
export function buildDefaultShipmentConfiguration(dataSourceType: string): ExcelConfiguration<Shipment> {
  return {
    name: "Default Shipping Labels",
    description: "Standard shipping label configuration with essential fields",
    dataSourceType,
    columns: [
      {
        id: "col_1",
        label: "Código do artigo",
        fieldMapping: "article_code",
        type: "text",
        required: true,
        visible: true,
        formatting: {
          alignment: "left",
          bold: true,
        },
      },
      {
        id: "col_2",
        label: "Barcode",
        fieldMapping: "barcode_value",
        type: "barcode",
        required: true,
        visible: true,
        formatting: {
          alignment: "center",
        },
      },
      {
        id: "col_3",
        label: "Nome do artigo",
        fieldMapping: "article_name",
        type: "text",
        required: true,
        visible: true,
        formatting: {
          alignment: "left",
        },
      },
      {
        id: "col_4",
        label: "Colour",
        fieldMapping: "colour",
        type: "text",
        required: false,
        visible: true,
        formatting: {
          alignment: "center",
        },
      },
      {
        id: "col_5",
        label: "Size",
        fieldMapping: "size",
        type: "text",
        required: false,
        visible: true,
        formatting: {
          alignment: "center",
        },
      },
      {
        id: "col_6",
        label: "Quantity",
        fieldMapping: "quantity",
        type: "number",
        required: true,
        visible: true,
        formatting: {
          alignment: "right",
          numberFormat: "#,##0",
        },
      },
      {
        id: "col_7",
        label: "Box",
        fieldMapping: "box_number",
        type: "number",
        required: false,
        visible: true,
        formatting: {
          alignment: "center",
        },
      },
    ],
    options: {
      includeHeader: true,
      freezeHeader: true,
      autoFitColumns: false,
      sheetName: "Shipping Labels",
      fileName: "shipping-labels",
    },
  };
}
